import request from '@/util/request'

export function login(data) {
  return request({
    url: '/account/login',
    method: 'post',
    data,
  })
}

export function changePassword(data) {
  return request({
    url: '/account/changePassword',
    method: 'post',
    data,
  })
}

export function getSupplierBankAccounts(query) {
  return request({
    url: '/supplier/bankAccount',
    method: 'get',
    params: query,
  })
}
